import React from 'react';
import {
    List, Datagrid, TextField,
    TextInput, SelectInput, SelectArrayInput, DateInput,
    downloadCSV, Pagination, ReferenceManyField, SingleFieldList,
    NullableBooleanInput, FunctionField, EditButton, useRecordContext, usePermissions
} from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import DeviceDaEsaminareShow from './deviceDaEsaminareShow';
import DevicesDaEsaminareActions from './deviceDaEsaminareActions';
import Attachment from '@mui/icons-material/Attachment';
import { Anomalie_Filter, Status_Regman, Flag_olo, Statuses_1_Approvatore, Check_u0009t, TipoFamiglia, Status_Collaudo_One, OneStep } from '../objects';
import ValidateRegmanButton from '../devices/Buttons/ValidateRegman';
import ResetCheckButton from './Buttons/ResetCheck';
import { useMediaQuery } from '@mui/material';

const PostPagination = () => <Pagination rowsPerPageOptions={[10, 25]} />;
const NonRegmanNMUs = localStorage.getItem('nonRegmanNMUs') ? localStorage.getItem('nonRegmanNMUs').split(',') : [];

export const DevicesDaEsaminareList = () => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const { permissions } = usePermissions();

    const ShowValidateRegmanButton = ({ ...rest }) => {
        const record = useRecordContext();
        if (!record) return null;
        
        let checkregman = false;

        if (record.status.codice === '0' && record.anomalia && ['15', '25'].includes(record.anomalia.codice) && record.cod_terr_sap !== "IMCNS093") {

            if (!NonRegmanNMUs.includes(record.cod_nmu.toString())) {
                if (!record.status_collaudo_one || ['0', '2'].includes(record.status_collaudo_one.codice)) checkregman = true;
            }

            //TO_SM_201
            if (checkregman === true && record.flag_olo === "SI" && record.progetto_con_scarico !== null) checkregman = false;
        }

        return checkregman ? <ValidateRegmanButton record={record} {...rest} /> : null;
    }

    const ShowResetCheckButton = ({ ...rest }) => {
        const record = useRecordContext();
        if (!record) return null;

        let canReset = false;

        if (record.status.codice === '0' && record.anomalia && ['15', '25'].includes(record.anomalia.codice) && !record.cod_terr_sap.startsWith("IB"))
            canReset = true;

        return canReset ? <ResetCheckButton record={record} {...rest} /> : null;
    }

    const ShowEditButton = ({ ...rest }) => {
        const record = useRecordContext();
        if (!record) return null;

        var status = record.status ? record.status.codice : '';
        var anomalia = record.anomalia ? record.anomalia.codice : '';
        var editBtn = <EditButton record={record} {...rest} />;

        if (permissions === 'approvatore') {
            if (status === '0' && anomalia === '0') {
                return editBtn;
            }
            else if (status === '1' || status === '6') {
                return editBtn;
            }
            else {
                return null;
            }
        }
        else {
            return null
        }
    }

    const exporter = devices => {
        const devicesForExport = devices.map(device => {
            const { ...deviceForExport } = device;
            deviceForExport.status = device.status && device.status.descrizione;
            deviceForExport.causale = device.causale && device.causale.descrizione;
            deviceForExport.anomalia = device.anomalia && device.anomalia.descrizione;
            deviceForExport.status_regman = device.status_regman && device.status_regman.descrizione;
            deviceForExport['NMU WR'] = device.lista_NMU;
            deviceForExport['codice_impresa_utilizzo'] = device.codice_impresa_name;
            deviceForExport['descr_impresa_utilizzo'] = device.descrizione_impresa;
            deviceForExport['File Allegato'] = device.attachment_flag ? 'SI' : 'NO';
            deviceForExport.status_collaudo_one = device.status_collaudo_one && device.status_collaudo_one.descrizione;
            deviceForExport.reverse = device.reverse && device.reverse.codice;
            if (device.note && device.note.includes('\n')) deviceForExport.note = device.note.replaceAll('\n', ' ');
            return deviceForExport;
        });
        const fields = ['serial_number_tim', 'serial_number_forn', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt', 'num_consegna', 'workrequestid', 'externalrefid', 'associated_at', 'associated_by',
        'causale', 'anomalia', 'status', 'wr_prodotti', 'cod_terr_sap', 'cod_nmu', 'codice_impresa_name', 'impianto', 'impianto_regman', 'status_regman', 'sent_to_sap', 'cod_proj', 'mac_address',
        'serial_number_cpe', 'cod_terr_sap_mos', 'check_NMU', 'desc_nmu', 'tipo_task', 'flag_olo', 'check_u0009t', 'importo_u0009t', 'NMU WR', 'tipo_inserimento', 'client_type', 'data_completamento_wr', 'area', 'codice_riscontro',
        'codice_impresa_utilizzo', 'descr_impresa_utilizzo', 'tipo_famiglia', 'cod_gruppo_tec', 'File Allegato', 'contatore', 'causale_addebito', 'note_addebito', 'post_delivery', 'wr_collaudo_one', 'impianto_collaudo_one',
        'data_collaudo_one', 'status_collaudo_one', 'equivalenza_prod_applicabile', 'validated_at', 'validated_by', 'reverse', 'note', 'one_step', 'approved_at', 'approved_by']  // order fields in the export
        const csv = convertToCSV({
            data: devicesForExport,
            fields: fields
        });
        downloadCSV(csv, `ApparatiDaEsaminare_${(new Date().getFullYear())}${("0" + (new Date().getMonth()+1)).slice(-2)}${("0" + new Date().getDate()).slice(-2)}${("0" + new Date().getHours()).slice(-2)}${("0" + new Date().getMinutes()).slice(-2)}${("0" + new Date().getSeconds()).slice(-2)}`);
    }

    const exporterDG = (devices) => {
        const devicesForExport = devices.map(device => {
            const { ...deviceForExport } = device;
            deviceForExport.status = device.status && device.status.descrizione;
            deviceForExport.causale = device.causale && device.causale.descrizione;
            deviceForExport.anomalia = device.anomalia && device.anomalia.descrizione;
            deviceForExport.status_regman = device.status_regman && device.status_regman.descrizione;
            deviceForExport['NMU WR'] = device.lista_NMU;
            deviceForExport['File Allegato'] = device.attachment_flag ? 'SI' : 'NO';
            deviceForExport.status_collaudo_one = device.status_collaudo_one && device.status_collaudo_one.descrizione;
            if (device.note && device.note.includes('\n')) deviceForExport.note = device.note.replaceAll('\n', ' ');
            return deviceForExport;
        });
        const fields = ['serial_number_tim', 'serial_number_forn', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt', 'num_consegna', 'workrequestid', 'externalrefid', 'associated_at', 'associated_by',
            'causale', 'anomalia', 'status', 'wr_prodotti', 'cod_terr_sap', 'cod_nmu', 'codice_impresa_name', 'impianto', 'impianto_regman', 'status_regman', 'sent_to_sap', 'approved_at', 'cod_proj', 'mac_address',
            'serial_number_cpe', 'cod_terr_sap_mos', 'check_NMU', 'desc_nmu', 'tipo_task', 'flag_olo', 'check_u0009t', 'importo_u0009t', 'NMU WR', 'note', 'tipo_inserimento', 'client_type', 'data_completamento_wr', 'area', 'codice_riscontro',
            'tipo_famiglia', 'cod_gruppo_tec', 'File Allegato', 'contatore', 'post_delivery', 'wr_collaudo_one', 'impianto_collaudo_one',
            'data_collaudo_one', 'status_collaudo_one', 'equivalenza_prod_applicabile', 'one_step']  // order fields in the export
        const csv = convertToCSV({
            data: devicesForExport,
            fields: fields
        });
        downloadCSV(csv, `ApparatiDeEsaminare_${(new Date().getFullYear())}${("0" + (new Date().getMonth()+1)).slice(-2)}${("0" + new Date().getDate()).slice(-2)}${("0" + new Date().getHours()).slice(-2)}${("0" + new Date().getMinutes()).slice(-2)}${("0" + new Date().getSeconds()).slice(-2)}`);
    }

    const listValidation = (value, allValues) => {
        let error;
        if (value && typeof value === "string" && value.includes(',')) {
            let reg = /^[a-zA-Z0-9%,]*$/;
            if (!reg.test(value)) {
                error = "Puoi usare solo % , 0-9 A-Z";
            }
            else if (value.split(',').length > 100) {
                error = "Il filtro contiene più di 100 seriali";
            }
        }

        //Normally all this is not needed but in this case we use serial_number_tim with alwaysOn and in this case the error message is not shown by react-admin
        if (error) {
            if (!document.getElementById('serial_number_tim-helper-text')) {
                let input = document.getElementById('serial_number_tim').parentElement;
                let label = document.getElementById('serial_number_tim-label');
                let parent = input.parentElement;

                let newChild = document.createElement('p');
                newChild.className = 'MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-filled css-u6loev-MuiFormHelperText-root';
                newChild.innerHTML = error;
                newChild.id = 'serial_number_tim-helper-text';
                newChild.style= 'display: block; font-size: 0.75rem; color: #d32f2f;';
                input.className = input.className + " Mui-error";
                label.className = label.className + " Mui-error";
                parent.appendChild(newChild);
            }
        }
        else if (document.getElementById('serial_number_tim-helper-text')){
            document.getElementById('serial_number_tim-helper-text').remove();
            document.getElementById('serial_number_tim').parentElement.className = document.getElementById('serial_number_tim').parentElement.className.replace(" Mui-error", "");
            document.getElementById('serial_number_tim-label').className = document.getElementById('serial_number_tim-label').className.replace(" Mui-error", "");
        }
        return error;
    };

    const formatSerialFilter = (v) => {
        if (v && v.$in && Array.isArray(v.$in)) {
            return v.$in.join()
        }
        return v;
    }

    const validateList = [listValidation]
    const ShowAttachmentIcon = () => {
        const record = useRecordContext();
        if (!record) return null;

        return record.attachment_flag ? <Attachment /> : null
    }

    const DeviceDaEsaminareFilter = [
        <SelectArrayInput source="status.codice" choices={Statuses_1_Approvatore} />,
        <TextInput source="workrequestid" />,
        <TextInput source="serial_number_tim" alwaysOn style={{ width: '275px' }} validate={validateList} format={formatSerialFilter} />,
        <TextInput source="serial_number_forn" />,
        <TextInput source="mac_address" />,
        <TextInput source="associated_by" />,
        <DateInput source="associated_at_gte" />,
        <DateInput source="associated_at_lte" />,
        <TextInput source="cod_terr_sap" />,
        <TextInput source="cod_terr_sap_mos" />,
        <TextInput source="impianto" />,
        <TextInput source="cod_nmu" />,
        <TextInput source="magmoi.codice_impresa_sap" label="Codice SAP Impresa" />,
        <SelectInput source="tipo_task" choices={[{ id: 'ASSURANCE', name: 'ASSURANCE' }, { id: 'DELIVERY', name: 'DELIVERY' }]} />,
        <SelectInput source="tipo_inserimento" choices={[{ id: 'Digitato', name: 'Digitato' }, { id: 'Scansionato', name: 'Scansionato' }, { id: 'DaLista', name: 'DaLista' }]} />,
        <TextInput source="approved_by" />,
        <SelectArrayInput source="anomalia.codice" choices={Anomalie_Filter} />,
        <SelectInput source="status_regman.codice" choices={Status_Regman} />,
        <DateInput source="createdAt_gte" />,
        <DateInput source="createdAt_lte" />,
        <TextInput source="num_consegna" />,
        <SelectInput source="flag_olo" choices={Flag_olo} />,
        ...(permissions === 'approvatore' || permissions === 'dg') ? [<SelectInput source="check_u0009t" choices={Check_u0009t} />] : [],
        <NullableBooleanInput source="attachment_flag" />,
        <DateInput source="data_completamento_wr_gte" />,
        <DateInput source="data_completamento_wr_lte" />,
        <SelectInput source="tipo_famiglia" choices={TipoFamiglia} label="Tipo Famiglia" />,
        <TextInput source="cod_gruppo_tec" />,
        <SelectInput source="contatore" choices={[{ id: 'NULL', name: '0' }, { id: 1, name: '1' }, { id: 2, name: '2' }, { id: 3, name: '3' }, { id: 4, name: '4' }, { id: 5, name: '5' }, { id: 6, name: '6' }
            , { id: 7, name: '7' }, { id: 8, name: '8' }]} label="Contatore" />,
        <SelectInput source="status_collaudo_one.codice" choices={Status_Collaudo_One} label="Stato CollaudoOne" />,
        <SelectInput source="one_step" choices={OneStep} label="ONE STEP" />,
        <TextInput source="nomenclatore.divresp" label="Divisione Responsabile" />
    ];

    return (
        <List empty={false} filters={DeviceDaEsaminareFilter} actions={<DevicesDaEsaminareActions />} exporter={permissions !== 'dg' ? exporter : exporterDG} pagination={<PostPagination />}  >
            {isSmall ? (
                <Datagrid rowClick="expand" expand={<DeviceDaEsaminareShow />} bulkActionButtons={false}>
                    <TextField source="serial_number_tim" />
                    <TextField source="workrequestid" />
                    <ShowEditButton />
                </Datagrid>
            ) : (
                <Datagrid rowClick="expand" expand={<DeviceDaEsaminareShow />} bulkActionButtons={false}>
                    <TextField source="serial_number_tim" />
                    <TextField source="workrequestid" />
                    <TextField source="divisione" />
                    <TextField source="codice_magazzino" />
                    <ReferenceManyField
                        resource="devices"
                        reference="magmois"
                        target="cod_terr_sap"
                        source="cod_terr_sap"
                        basePath="/devices"
                        label="Codice SAP Impresa"
                        linkType={false}
                    >
                        <SingleFieldList linkType={false}>
                            <TextField source="codice_impresa_sap" />
                        </SingleFieldList>
                    </ReferenceManyField>
                    <TextField source="impianto" />
                    <TextField source="cod_nmu" />
                    <TextField source="status.descrizione" />
                    <TextField source="causale.descrizione" />
                    <TextField source="anomalia.descrizione" />
                    <ShowAttachmentIcon />
                    <FunctionField label="Contatore" render={record => { return record.contatore ? record.contatore : 0 }} />
                    <ShowValidateRegmanButton />
                    <ShowResetCheckButton />
                    <ShowEditButton />
                </Datagrid>
            )}
        </List>
    );
}
